import script from "./NewPasswordForm.vue?vue&type=script&setup=true&lang=js"
export * from "./NewPasswordForm.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__